<template>
    <div class="layout-wrapper">
        <common-layout class="default-layout">
            <template #header>
                <header-component v-if="featureHeaderEnabled"/>
            </template>
        </common-layout>
    </div>
</template>

<script setup lang="ts">
    import HeaderComponent from "@/components/Header/Header.vue";
    import CommonLayout from "./common.vue";

    const {featureHeaderEnabled} = useAppConfig();
</script>
